export default __webpack_public_path__ + "static/media/pill.52d5302d.svg";